export default "__VITE_ASSET__391dmXvT__"